export default __webpack_public_path__ + "static/media/iconMerchants.10653ac1.svg";